// Truncated cell that shows tooltip when content overflows.
import React from 'react';
import PropTypes from 'prop-types';
import OverflowTooltip from '@shared/overflow-tooltip';

const TruncatedCell = ({ children, tooltip, ...props }) => (
  <OverflowTooltip title={tooltip} {...props}>
    {children}
  </OverflowTooltip>
);

TruncatedCell.propTypes = {
  children: PropTypes.node,
  // targetId: when provided, checks overflow on element with id="item_label_{targetId}"
  // Used for icon+label combos where only the label should trigger tooltip
  targetId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};

export default TruncatedCell;
